import * as R from "ramda";
import { Typography } from "@mui/material";
import React, { useContext } from "react";
import styled from "styled-components";
import { Title } from "components/Typography";
import { LanguageContext } from "contexts/language.context";
import { Translate, UpcomingOrMonthYear } from "utils/translate";

const Gutter = styled.div`
  padding-left: 1.25rem;
`;

const Container = styled.div`
  margin-bottom: 1.25rem;
`;

const Events = () => {
  const { language } = useContext(LanguageContext);
  const upcoming = Translate(language, ["EVENTS", "upcoming"]);
  const { keys, events } = R.pipe(
    R.map(R.over(R.lensProp("date"), UpcomingOrMonthYear)),
    R.map(R.when(R.propEq("date", ""), R.assoc("date", upcoming))),
    R.groupBy(R.prop("date")),
    (o) => R.zipObj(["keys", "events"], [R.keys(o), o])
  )(Translate(language, ["EVENTS", "data"]));

  return (
    <div>
      <Title variant="h5">{Translate(language, ["EVENTS", "title"])}</Title>
      {keys.map((key) => (
        <Container>
          <Typography variant="h6" sx={{ marginBottom: "0.5rem" }}>
            {key}
          </Typography>
          <Gutter>
            <ul>
              {events[key].map((event) => (
                <li>
                  {event.name}
                  <Gutter>{event.comments}</Gutter>
                  <Gutter>
                    <Typography variant="caption" sx={{ fontStyle: "italic" }}>
                      {event.location}
                    </Typography>
                  </Gutter>
                </li>
              ))}
            </ul>
          </Gutter>
        </Container>
      ))}
    </div>
  );
};

export default Events;
